// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3JWzy","paymentContainer":"PaymentPage_paymentContainer__3uU4M"};